import React from "react";
import clsx from "clsx";
import {
  SelectProject,
  ViewDataFlow,
  DesignView,
  ViewDataModelPage,
  ViewProjectQuality,
} from "../BreadcrumbComponents/index";

const ViewProjectDataModelBreadcrumb = (props) => {
  const { selectedProject, setSelectedProject } = props;

  const changeProject = (option) => {
    let index = 0;

    JSON.parse(localStorage.getItem("data")).forEach((element, indexEl) => {
      if (element.name === option) {
        index = indexEl;
      }
    });

    setSelectedProject(index);
    localStorage.setItem("selectedProject", index);
  };

  return (
      <div style={{ backgroundColor: "#CFD8E0" }}>
        <div
          className={clsx("generalMarg", "flexRowDirection")}
          style={{ justifyContent: "space-between" }}
        >
          <div
            className={clsx("flexRowDirection")}
            style={{ width: "75%", padding: "0vw" }}
          >
            <SelectProject
              changeProject={changeProject}
              selectedProject={selectedProject}
            />
          </div>
          <div className={clsx("flexRowDirection")}>
            <ViewDataModelPage />
            <ViewDataFlow />
            <ViewProjectQuality />
            <DesignView selectedProject={selectedProject} />
          </div>
        </div>
      </div>
  );
};

export default ViewProjectDataModelBreadcrumb;
